import { type ISourceOptions } from '@tsparticles/engine';
import themecolor from '../../theme';

export const getParticleOptions = (theme: string): ISourceOptions => {
  const primarycolor = theme === 'casual' ? themecolor.casualprimary : themecolor.businessprimary;
  const secondarycolor =
    theme === 'casual' ? themecolor.casualsecondary : themecolor.businesssecondary;

  return {
    key: 'linkTriangles',
    name: 'Link Triangles',
    fullScreen: {
      enable: false,
    },
    particles: {
      number: {
        value: 130,
        density: { enable: true },
      },
      color: {
        value: primarycolor,
      },
      shape: {
        type: 'circle',
      },
      opacity: {
        value: 0.2,
      },
      size: {
        value: { min: 1, max: 4 },
      },
      links: {
        enable: true,
        distance: 150,
        color: secondarycolor,
        opacity: 0.2,
        width: 1,
        triangles: {
          enable: true,
          color: '#efefef',
          opacity: 0.05,
        },
      },
      move: {
        enable: true,
        speed: 3,
      },
    },
    background: {
      color: '#ffffff',
      opacity: 0,
    },
  };
};
